'use client';

import Image404 from '@/assets/images/404.png';
import { useStyle } from '@/classify';
import { CartEmptyCloneFor404 } from '@/components/CartEmpty/cartEmptyCloneFor404';
import { useHeader } from '@/hooks/Header/useHeader';
import Image from 'next/image';
import SearchBar from '../SearchBar';
import defaultClasses from './errorView.module.css';
const ErrorView = props => {
  const classes = useStyle(defaultClasses, props.classes);

  const { handleSearchTriggerClick } = useHeader();

  const afterSearchSubmit = () => {
    handleSearchTriggerClick();
  };

  return (
    <div className='personalContent mx-auto px-[12px] py-[40px] lg_px-0 lg_pb-[80px] lg_pt-[60px]'>
      <div className='mx-auto mb-[40px] w-full px-[10%] lg_mb-[60px] lg_w-[600px] lg_px-0'>
        <Image
          src={Image404}
          alt='404 Not Found'
          width={400}
          height={400}
          className='w-full'
        />
      </div>

      <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
        Oops! The page is disappeared!
      </p>
      <SearchBar
        isOpen
        classes={{
          root_open: 'py-0',
          autocomplete: classes.autocomplete,
          form: classes.form,
          container: 'w-full',
          search: classes.search,
        }}
        afterSubmit={afterSearchSubmit}
      />
      <div className='mb-[40px] mt-[40px] lg_mb-[60px]'>
        <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
          Let's get you back on track...
        </p>
        <CartEmptyCloneFor404
          classes={{
            emptyCart: '',
            buttonsContainer: 'flex flex-col lg_flex-row gap-[20px] lg_gap-[25px]',
            linkButton:
              'lg_w-[200px] lg_h-[50px] w-full h-[40px] border-1 border-solid border-black bg-white hover_bg-black text-black hover_text-white font-roboto-medium text-[16px] lg_text-[18px] rounded-full text-center leading-[40px] lg_leading-[50px] transition-all duration-300',
            emptyMessage: classes.emptyMessage,
            advertisingSpace: classes.advertisingSpace,
          }}
        />
      </div>

      <div className=''>
        <p className='mb-[20px] font-teko-medium text-[30px] uppercase leading-[28px] text-primary lg_text-[40px] lg_leading-[48px]'>
          Still have questions?
        </p>
        <span className='font-roboto-regular text-[16px] font-normal lg_text-[18px]'>
          Feel free to contact us at{' '}
          <a
            href='mailto:<cs@hisea.com>'
            className='font-roboto-medium text-[16px] font-medium underline hover_text-primary lg_text-[18px]'
          >
            cs@hisea.com
          </a>
          . We will reply within 48 hours.
        </span>
      </div>
    </div>
  );
};

export default ErrorView;
